import 'slick-carousel/slick/slick'

export default class TestimonialSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-testimonials-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                prevArrow: $('.js-testimonials-previous'),
                nextArrow: $('.js-testimonials-next'),
                appendDots: $('.js-testimonials-dots'),
            });
        }

    }

};

new TestimonialSlider();